export default __webpack_public_path__ + "static/image-3-mob-45e00422029fca7fa2758905664cb573.jpg";